import { Skeleton, Stack } from '@mui/material';

import {
  agentStatusToLabel,
  getAgentStatusColor,
} from '../../../helpers/agentHelper';
import useLoadAgentImage from '../../../hooks/useLoadAgentImage';
import { useTranslation } from '../../../hooks/useTranslation';
import { AgentStatus } from '../../../interfaces/Agent';
import StyledAgentImage from '../../../styles/StyledAgentImage';
import OnlineIcon from '../Icons/OnlineIcon';
import StyledIcon from '../Icons/StyledIcon';
import TextTruncated from '../TextTruncated/TextTruncated';
import StyledAgentName from '../AgentProfileAvatar/StyledAgentName';

type ChatAgentProfileAvatarProps = {
  agentId?: string;
  avatarUrl?: string;
  agentName?: string;
  agentStatus?: AgentStatus;
  hideAgentName?: boolean;
  showAgentStatus?: boolean;
  width?: string;
};

const ChatAgentProfileAvatar: React.FC<ChatAgentProfileAvatarProps> = ({
  avatarUrl,
  agentName,
  agentStatus = AgentStatus.IN_REVIEW,
  hideAgentName = false,
  showAgentStatus = true,
  width = '100%',
}) => {
  const { t } = useTranslation();
  const translatedAgentName = agentName || t('Chat Agent');

  return (
    <Stack position="relative" minHeight="400px">
      {!hideAgentName && (
        <StyledAgentName>
          <TextTruncated title={translatedAgentName} width={width}>
            {translatedAgentName}
          </TextTruncated>
        </StyledAgentName>
      )}
      {avatarUrl ? (
        <StyledAgentImage src={avatarUrl} alt={t('Chat Agent')} width={width} />
      ) : (
        <Stack>
          <Skeleton
            data-testid="chat-agent-profile-avatar-skeleton"
            variant="rounded"
            width="400px"
            height="400px"
          />
        </Stack>
      )}
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        marginTop="10px"
      >
        {showAgentStatus && (
          <StyledIcon
            gap="0.5rem"
            textTransform="uppercase"
            color={getAgentStatusColor(agentStatus)}
          >
            <OnlineIcon
              width={16}
              height={16}
              fill={getAgentStatusColor(agentStatus)}
            />
            {agentStatusToLabel(agentStatus, t)}
          </StyledIcon>
        )}
      </Stack>
    </Stack>
  );
};

export default ChatAgentProfileAvatar;
